import React, { useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import MainPageDialog from "../../components/dialog";
import { InputField } from "../../components/reactHookFormFields/inputField";
import baseApiHelper from "../../services/baseApiHelper";
import { useCheckRoomMutation, useCreateRoomMutation } from "../../services/vezoService";


export const CreateRoomDialog = ({closeHandler}) => {


    const [isValidRoomName, setIsValidRoomName] = useState(false);
    const [checkRoom, {isLoading: ischeckingRoom}] = useCheckRoomMutation();
    const [createRoom, {isLoading}] = useCreateRoomMutation();

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({});

    const vezoIdVal = useWatch({ control, name: 'vezo_id' });
    const footerList = [
        {
            title: 'Create',
            type: "save",
            action: () => {
                handleSubmit(onSubmit)();
            }
        },
        {
            title: "Cancel",
            type: "cancel",
            action: () => {
                closeHandler();
            }
        }
    ];

    const checkRoomNameAvailablity = (val) => {
        if(val?.length > 2){
            checkRoom({vezo_id: val}).then((res) => {
                if(res?.data){
                    setIsValidRoomName(res.data.available)
                    baseApiHelper().invalidateTags(["vezoRooms"]);
                }
                else {
                    toast.error(res?.data?.response?.msg);
                }
            })
        }
    }

    const onSubmit = (values) => {
        createRoom(values).then((res) => {
            if(res?.data){
                toast.error(res?.data?.msg);
                closeHandler('submit');
            }
        })
       
    }

    return (
        <MainPageDialog
            title="Create your room"
            footer={true}
            footerList={footerList}
            modalSize="md"
            onCancelHandler={() => closeHandler()}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col gap-4">
                    <InputField
                        title="Room Name"
                        name="name"
                        control={control}
                        errors={errors}
                        rules={{
                            required: {
                                value: true,
                            },
                        }}
                    />
                    <div className="text-start">
                        <InputField
                            title="Vezo ID"
                            name="vezo_id"
                            control={control}
                            onChange={(e)=>checkRoomNameAvailablity(e.target.value)}
                            autoComplete="false"
                            errors={errors}
                            rules={{
                                required: {
                                    value: true,
                                },
                                minLength: {
                                    value: 3,
                                    message: "Vezo ID must be at least 3 characters long",
                                },
                            }}
                        />
                        <p>
                            {ischeckingRoom ? <FaSpinner className="animate-spin text-green-300-500 ml-0 inline" size={15} /> : null}
                            {(!ischeckingRoom && vezoIdVal?.length > 2) ?
                                <span className={`${isValidRoomName ? 'text-green-400' : 'text-red-400'}`}>Vezo ID is {isValidRoomName ? 'available' : 'already taken'}</span>
                                : null
                            }
                        </p>
                    </div>
                </div>
            </form>
        </MainPageDialog>
    );
};
